import React, { useState, useEffect } from 'react';
import MainLayout from '../../../shared/components/MainLayout';
import SmartTable, { SmartTableColumn } from '../../../shared/components/SmartTable';

const receiptColumns: SmartTableColumn[] = [
  { key: 'Oid', label: 'Oid' },
  { key: 'CustomerId', label: 'CustomerId' },
  { key: 'Number', label: 'Number' },
  { key: 'BillId', label: 'BillId' },
  { key: 'Date', label: 'Date' },
  { key: 'YearType', label: 'YearType' },
  { key: 'PeriodType', label: 'PeriodType' },
  { key: 'BusinessCustomerId', label: 'BusinessCustomerId' },
  { key: 'CityTaxAmount', label: 'CityTaxAmount' },
  { key: 'VATPayableAmount', label: 'VATPayableAmount' },
  { key: 'NonVATSalesAmount', label: 'NonVATSalesAmount' },
  { key: 'VATInclusiveSalesAmount', label: 'VATInclusiveSalesAmount' },
  { key: 'VATReceivableAmount', label: 'VATReceivableAmount' },
  { key: 'NonVATPurchaseAmount', label: 'NonVATPurchaseAmount' },
  { key: 'VATInclusivePurchaseAmount', label: 'VATInclusivePurchaseAmount' },
  { key: 'WorkTaskId', label: 'WorkTaskId' },
  { key: 'Operation', label: 'Operation' },
  { key: 'CreateDate', label: 'CreateDate' },
];

const EBarimtPage: React.FC = () => {
  const [receipts, setReceipts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchReceipts = async () => {
    setLoading(true);
    try {
      const response = await fetch('/receipt');
      const data = await response.json();
      if (data.success) {
        setReceipts(data.data || []);
      }
    } catch (error) {
      console.error('Error fetching receipts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReceipts();
  }, []);

  // Add handler for the analyze button
  const handleAnalyze = () => {
    alert('Шинжлэх clicked!');
  };

  return (
    <MainLayout>
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-4">E-Barimt</h2>
        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="text-gray-500">Уншиж байна...</div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow p-6">
            <SmartTable
              data={receipts}
              columns={receiptColumns}
              fetchData={fetchReceipts}
              settingsKey="receipt-table"
              editable={false}
              addable={false}
              rowKey="Oid"
              analyzeButton={{ label: 'Шинжлэх', onClick: handleAnalyze }}
            />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default EBarimtPage; 